import axios from 'axios';
import jsonp from 'jsonp';
import querystring from 'querystring';
import {getCookie} from '@auto/js-cookie';

const vm = {
  // 获取 cookie
  getLc(t) {
    return getCookie(t);
  },
  // 清除 cookie
  clearLc(t) {
    document.cookie = t + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  },
  getSessionid() {
    var sessionid = vm.getLc('sessionid');
    if (sessionid) return sessionid.split('|')[0];
    const newSession = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    }) + '-' + new Date() * 1;
    return newSession;
  },
  // 超过万返回小数
  getGreatNumber(n) {
    let num;
    if (n < 10000 || (typeof(n) === 'string' && n.indexOf(/万|w|亿/) > -1)) return n;
    if (n > 99999999) {
      num = Math.floor(n / 10000000) / 10;
      return num + '亿';
    }
    if (n > 999999) {
      num = Math.floor(n / 10000);
    } else {
      num = Math.floor(n / 1000) / 10;
    }
    return num + 'w';
  },
  // 返回时长
  getSecond(n) {
    const h = Math.floor(n / 3600);
    let hour = '';
    if (h) hour = vm.addZero(h) + ':';
    return hour + vm.addZero(Math.floor((n % 3600) / 60)) + ':' + vm.addZero((n % 3600) % 60);
  },
  addZero(num) {
    let t;
    if (num === 0) {
      t = '00';
    } else if (num < 10) {
      t = '0' + num;
    } else {
      t = num;
    }
    return t;
  },
  // 多久之前
  /**
   * 
   * @param {Date} n 
   * @param {Boolean} m 是否显示时间
   * @returns 
   */
  getTimeAgo(n, m) {
    const then = new Date(n);
    const long = new Date() - then;
    const minutes = m ? (' ' + vm.addZero(then.getHours()) + ':' + vm.addZero(then.getMinutes())) : '';
    // const times = [2678400000, 604800000, 86400000, 3600000, 60000];
    // const text = ['个月前', '周前', '天前', '小时前', '分钟前'];
    const times = [604800000, 86400000, 3600000, 60000];
    const text = ['周', '天前', '小时前', '分钟前'];
    let count = 0;
    if (times.some((item, index) => {
      count = index;
      return long / item > 1;
    })) {
      const num = Math.floor(long / times[count]);
      if (count === 0 || (count === 1 && m && num > 1)) return `${then.getFullYear()}-${then.getMonth() + 1}-${then.getDate()}${minutes}`;
      else if (count === 1 && num === 1) return `昨天${minutes}`
      return num + text[count];
    }
    return '刚刚';
  },
  getTimeLate(n) {
    const then = new Date(n);
    const today = new Date();
    const minutes = (' ' + vm.addZero(then.getHours()) + ':' + vm.addZero(then.getMinutes()));
    let text = `${then.getMonth() + 1}-${then.getDate()}`;
    const long = then - today < (86400000 * 2);
    if (long && then.getDate() - today === 0) {
      text = '今天';
    } else if (long && then.getDate() - today === 1) {
      text = '明天';
    }
    return text + minutes;
  },
  // 返回元素位置
  getElementPosition(e) {
    let x = 0, y = 0, width = 0, height = 0;
    while (e != null) {
      x += e.offsetLeft;
      y += e.offsetTop;
      if (width === 0) width = e.offsetWidth;
      if (height === 0) height = e.offsetHeight;
      e = e.offsetParent;
    }
    return { x, y, width, height};
  },
  // 数组乱序
  randomIndex(r) {
    for (let i = 0, len = r.length; i < len; i++) {
      // 随机选择一个队友
      const randomIndex = i + Math.floor(Math.random() * (len - i));
      // 咱俩换换，找别人换过的相当于出列了，因此上面的 randomIndex 需要在剩下的人当中挑选
      const temp = r[i];
      r[i] = r[randomIndex];
      r[randomIndex] = temp;
    }
    return r;
  },
  // 返回 m到n随机数
  // 注释：(n-m+1) + 1 确定是否取到得随机数含有n。
  randomNum(m, n) {
    return Math.floor(Math.random() * (n - m + 1) + m);
  },
  removeRepeat(upData, downData) {
    if (!upData.items) return downData;
    if (!downData.items) return upData;
    let [newUpData, newDownData] = [upData, downData];
    if (upData.items && downData.items) {
      newUpData = upData.items;
      newDownData = downData.items;
    }
    const softData = {};
    let newData =  [...newUpData, ...newDownData].reduce((cur, next) => {
      if (!softData[next.objectid]) softData[next.objectid] = true && cur.push(next);
      return cur;
    }, []);
    if (downData.items) {
      downData.items = newData;
      newData = {...upData, ...downData};
    }
    return newData;
  },
  // 获取手机类型
  getMobileType() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return 'Android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }
    return 'unknown';
  },
  // 获取url参数
  getUrlParams(name, url) {
    if (!url) url = document.location.href;
    const regexS = '[\\?&]' + name + '=([^&#]*)';
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    return results == null ? null : results[1];
  },
  // ajax
  ajax(opt, jsp) {
    if (jsp) {
      jsonp(opt.url + '?' + querystring.encode(opt.data), null, (err, data) => {
        if (!err) opt.success && opt.success(data);
      });
    } else {
      axios({
        method: opt.type || 'get',
        url: opt.url,
        params: opt.data,
      }).then((res) => {
        opt.success && opt.success(res.data);
      }).catch((data) => {
        opt.error && opt.error(data);
      });
    }
  },
  /**
   * 函数节流方法
   * @param Function fn 延时调用函数
   * @param Number delay 延迟多长时间
   * @param Number atleast 至少多长时间触发一次
   * @return Function 延迟执行的方法
   */
  throttle(fn, dly, atl) {
    let timer;
    let previous;
    const delay = dly || 500;
    const atleast = atl || 1000;
    return function () {
      const now = new Date().getTime();
      if (!previous) previous = now;
      if (now - previous > atleast) {
        fn();
        // 重置上一次开始时间为本次结束时间
        previous = now;
      } else {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn();
        }, delay);
      }
    };
  },
};
export {
  vm as default,
};

